export class StatsTableHeaders {
    public static detailedStatsUruchomieniaHeader(): Array<object> {
        return  [
            {
                text: 'Data',
                sortable: false,
                value: 'data'
            },
            {
                text: 'Godz.',
                sortable: true,
                value: 'data'
            },
            {
                text: 'Ilość rozliczeń',
                sortable: true,
                align: 'center',
                value: 'deklaracje_count'
            },
            {
                text: 'Suma 1% (zł)',
                sortable: true,
                align: 'center',
                value: 'deklaracje_kwota'
            },
            {
                text: 'OS',
                sortable: false,
                value: 'os'
            },
            {
                text: 'IP',
                sortable: false,
                value: 'ip'
            },
        ];
    }

    public static detailedStatsPobraniaHeader(): Array<object> {
        return [
            {
                text: 'Data',
                sortable: false,
                value: 'data'
            },
            {
                text: 'Godz.',
                sortable: true,
                value: 'data'
            },
            {
                text: 'Uruchomień',
                sortable: true,
                align: 'center',
                value: 'uruchomienia_count'
            },
            {
                text: 'Pobrano z',
                sortable: true,
                value: 'referer'
            },
            {
                text: 'OS',
                sortable: false,
                value: 'os'
            },
            {
                text: 'IP',
                sortable: false,
                value: 'ip'
            },
        ];
    }

    public static aggregatedStatsHeader(): Array<object> {
        return [
            {
                text: 'Data',
                sortable: false,
                value: 'data'
            },
            {
                text: 'Ilość',
                sortable: false,
                align: 'center',
                value: 'ilosc'
            },
            {
                text: '',
                value: 'data-table-expand'
            },
        ];
    }

    public static aggregatedStatsDeklaracjeHeader(): Array<object> {
        return [
            {
                text: 'Data',
                sortable: true,
                value: 'data'
            },
            {
                text: 'Suma',
                sortable: true,
                align: 'center',
                value: 'kwota'
            },
            {
                text: '',
                value: 'data-table-expand'
            },
        ];
    }

    public static detailedStatsDeklaracjeHeader(): Array<object> {
        return [
            {
                text: 'Data',
                sortable: true,
                value: 'data'
            },
            {
                text: 'Godz.',
                sortable: true,
                value: 'data'
            },
            {
                text: 'Kwota',
                sortable: true,
                value: 'kwota'
            },
            {
                text: 'Zestaw',
                sortable: true,
                value: 'zestaw'
            },
            {
                text: 'KRS',
                sortable: true,
                value: 'krs'
            },
            {
                text: 'Cel szczegółowy',
                sortable: true,
                value: 'cel_szczegolowy'
            },
            {
                text: 'Miasto',
                sortable: true,
                value: 'miasto'
            },
            {
                text: 'Województwo',
                sortable: true,
                value: 'wojewodztwo'
            },
            {
                text: 'Pobrano z',
                sortable: true,
                value: 'referer'
            },
            {
                text: 'OS',
                sortable: false,
                value: 'os'
            },
            {
                text: 'IP',
                sortable: false,
                value: 'ip'
            },
        ];
    }

}
